(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /**
   * Enhanced StickyHeader component that includes announcement bar in sticky behavior
   *
   * Features:
   * - Makes both announcement bar and header stick together on scroll
   * - Handles dynamic height changes with ResizeObserver
   * - Maintains proper z-index layering
   * - Supports all existing sticky header types (always, on-scroll-up, reduce-logo-size)
   */
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        if (this.announcementBar) {
          this.announcementBar.classList.add('shopify-section-announcement-sticky');
        }
      } else if (this.getAttribute('data-sticky-type') === 'none') {
        // Don't make announcement bar sticky when header sticky is set to 'none'
        if (this.announcementBar) {
          this.announcementBar.classList.remove(
            'shopify-section-announcement-sticky',
            'shopify-section-announcement-hidden',
            'animate'
          );
        }
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.createResizeObserver();
    }

    setHeaderHeight() {
      let totalHeight = this.header.offsetHeight;
      if (this.announcementBar) {
        const announcementHeight = this.announcementBar.offsetHeight;
        totalHeight += announcementHeight;
        document.documentElement.style.setProperty('--announcement-height', `${announcementHeight}px`);
      } else {
        document.documentElement.style.setProperty('--announcement-height', '0px');
      }
      document.documentElement.style.setProperty('--header-height', `${totalHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    createResizeObserver() {
      if (this.announcementBar) {
        this.resizeObserver = new ResizeObserver(() => {
          this.setHeaderHeight();
        });
        this.resizeObserver.observe(this.announcementBar);
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      if (this.announcementBar && this.getAttribute('data-sticky-type') !== 'none') {
        this.announcementBar.classList.add(
          'shopify-section-announcement-hidden',
          'shopify-section-announcement-sticky'
        );
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      if (this.announcementBar && this.getAttribute('data-sticky-type') !== 'none') {
        this.announcementBar.classList.add('shopify-section-announcement-sticky', 'animate');
        this.announcementBar.classList.remove('shopify-section-announcement-hidden');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (this.announcementBar && this.getAttribute('data-sticky-type') !== 'none') {
        this.announcementBar.classList.remove(
          'shopify-section-announcement-hidden',
          'shopify-section-announcement-sticky',
          'animate'
        );
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
